import { useState } from 'preact/hooks';
import { ApiError, api } from '../../lib/api.js';
import { Button } from '../../components/Button.jsx';

export const NewBookModal = ({ open, onClose, onCreated }) => {
  const [name, setName] = useState('');
  const [kind, setKind] = useState('custom');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const save = async () => {
    if (!name.trim()) return;
    setBusy(true);
    setError(null);
    try {
      const book = await api.post('/ink-books', { name: name.trim(), kind });
      setName('');
      setKind('custom');
      onCreated?.(book);
    } catch (err) {
      setError(err);
    } finally {
      setBusy(false);
    }
  };

  if (!open) return null;
  return (
    <div
      class="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto bg-black/55 px-4 py-10"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div class="w-full max-w-sm overflow-hidden rounded-xl border border-border-subtle bg-bg-base">
        <div class="border-b border-border-subtle bg-bg-header px-5 py-4">
          <p class="eyebrow mb-1" style={{ color: '#FF8A4C' }}>New ink book</p>
          <p class="m-0 text-sm text-text-secondary">Books group inks (Pantone, designer, or custom).</p>
        </div>

        <div class="space-y-4 p-5">
          <div>
            <p class="mb-1.5 text-[12px] font-semibold text-text-tertiary">Name</p>
            <input
              type="text"
              autoFocus
              value={name}
              onInput={(e) => setName(e.currentTarget.value)}
              class="block w-full rounded-md border border-border-strong bg-bg-card px-3 py-2 text-sm font-medium text-text-primary placeholder:text-text-muted focus:border-brand focus:outline-none focus:ring-1 focus:ring-brand"
              placeholder="e.g. J&P brand inks"
            />
          </div>

          <div>
            <p class="mb-1.5 text-[12px] font-semibold text-text-tertiary">Kind</p>
            <div class="flex overflow-hidden rounded-md border border-border-strong">
              {['custom', 'designer', 'pantone'].map((k) => (
                <button
                  key={k}
                  type="button"
                  onClick={() => setKind(k)}
                  class={`flex-1 px-3 py-2 text-[13px] font-semibold capitalize ${kind === k ? 'bg-brand text-[#1A0E04]' : 'bg-transparent text-text-tertiary hover:bg-bg-card'}`}
                >
                  {k}
                </button>
              ))}
            </div>
          </div>

          {error && (
            <p class="text-[13px] font-semibold text-ink-magenta">
              {error instanceof ApiError ? error.message : (error.message ?? 'Failed to create')}
            </p>
          )}
        </div>

        <div class="flex justify-end gap-2 border-t border-border-subtle bg-bg-header px-5 py-3">
          <Button variant="secondary" onClick={onClose} disabled={busy}>Cancel</Button>
          <Button variant="primary" onClick={save} disabled={busy || !name.trim()}>
            {busy ? 'Creating…' : 'Create book'}
          </Button>
        </div>
      </div>
    </div>
  );
};
